import { gql } from '@apollo/client'

export const LOAD_WEBSITE_DATA = gql`
    query loadWebsiteData($website: ID!) {
        loadWebsite(websiteID: $website) {
            id
            name
            elementDefinitions
            previewURL
            createdAt
            updatedBy {
                id
                name
            }
            updatedAt
        }
        loadPages(websiteID: $website) {
            id
            parentPageIdentifier
            sortIndex
            deactivated
            historyVersions {
                ID
                pageID
                state
                contents
                createdAt
                updatedAt
                pageSettings {
                    htmlTitle
                    urlTitle
                    metaDescription
                    metaKeywords
                    robotsOption
                    includeInSitemapXML
                    pageRank
                    changeFrequency
                    language
                    translationID
                }
                updatedBy {
                    id
                    name
                }
            }
            currentVersion {
                state
                pageSettings {
                    htmlTitle
                    urlTitle
                    language
                    translationID
                }
                updatedBy {
                    id
                    name
                }
                createdAt
                updatedAt
            }
            createdAt
            updatedAt
        }
        loadBlocks(websiteID: $website) {
            id
            identifier
            createdAt
            currentVersion {
                id
                name
                contents
                state
                updatedBy {
                    id
                    name
                }
                createdAt
                updatedAt
            }
            historyVersions {
                name
                id
                blockID
                state
                contents
                createdAt
                updatedAt
                updatedBy {
                    id
                    name
                }
            }
        }
        assets(websiteID: $website) {
            assets {
                id
                name
                sizeBytes
                type
                url
                thumbnailUrl
                tags
                websiteID
                folder
                updatedAt
                updatedBy
                createdAt
                createdBy
            }
            folders {
                id
                websiteID
                name
                tags
                parentFolder
                createdAt
            }
        }
    }
`
